import { Checkbox as MuiCheckbox, FormControlLabel } from '@material-ui/core';
import { useField } from 'formik';
import React from 'react';

export const CheckboxWithOnChange = ({ name, label, onChange, ...props }) => {
  const [field] = useField(name);
  return (
    <FormControlLabel
      control={<MuiCheckbox {...field} checked={field.value} onChange={onChange} />}
      label={label}
      {...props}
    />
  );
};
